import React from "react";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import HomeTwoToneIcon from "@material-ui/icons/HomeTwoTone";
import Toolbar from "@material-ui/core/Toolbar";
import RestoreFromTrashIcon from "@material-ui/icons/RestoreFromTrash";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import { BrowserRouter, Link } from "react-router-dom";
import { Box, Grid } from "@material-ui/core";
import GroupAddIcon from "@material-ui/icons/GroupAdd";
import customLocalStorage from "../common/local-storage";
import SupervisedUserCircleIcon from "@material-ui/icons/SupervisedUserCircle";
import SettingsApplicationsIcon from "@material-ui/icons/SettingsApplications";
import Profile from "./profile";

const theme = createMuiTheme({
  overrides: {
    MuiTabs: {
      indicator: {
        backgroundColor: "#ffffff",
      },
    },
    MuiTab: {
      root: {
        "&$selected": {
          backgroundColor: "#52B44B",
          color: "#52B44B",
          "&:hover": {
            color: "#52B44B",
          },
        },
      },
    },
  },
});

const TopNavBar = (props) => {
  const { menu, handleMenuChange, isSignedIn } = props;
  const user = customLocalStorage.decrypt("iwmUser");
  const styles = {
    tab: {
      color: "#FFFFFF",
    },
  };

  const isAdmin = user?.is_admin && isSignedIn ? true : false;
  // console.log({ isAdmin });

  return (
    <MuiThemeProvider theme={theme}>
      <AppBar position="static" style={{ background: "#52B44B" }}>
        <Toolbar>
          <Box
            display="flex"
            justifyContent="center"
            m={1}
            p={1}
            bgcolor="background.paper"
            style={{
              borderRadius: "1rem",
            }}
          >
            <BrowserRouter>
              <Link to="/">
                <img src={"/logo.png"} alt="Logo" />
              </Link>
              {/* <Link to="/uat/integrated-waste-management-ui">
                <img
                  src={"/uat/integrated-waste-management-ui/logo.png"}
                  alt="Logo"
                />
              </Link> */}
            </BrowserRouter>
          </Box>
          <Box fontWeight="fontWeightBold" m={1}>
            {process.env.REACT_APP_NAME}
          </Box>
          <Box display="flex" justifyContent="center" m={1} p={1}>
            <Tabs
              value={menu}
              onChange={(evt, value) => {
                handleMenuChange({ menu: value });
              }}
              variant="scrollable"
              scrollButtons="auto"
              aria-label="scrollable auto tabs example"
            >
              {user && isSignedIn && (
                <Tab
                  label="Home"
                  value="Home"
                  style={styles.tab}
                  icon={<HomeTwoToneIcon />}
                />
              )}
              {user && isSignedIn && (
                <Tab
                  label="Collection"
                  value="WasteCollection"
                  style={styles.tab}
                  icon={<RestoreFromTrashIcon />}
                />
              )}
              {isAdmin && (
                <Tab
                  label="Users"
                  value="UserManagement"
                  style={styles.tab}
                  icon={<GroupAddIcon />}
                />
              )}
              {isAdmin && (
                <Tab
                  label="Partners"
                  value="PartnerManagement"
                  style={styles.tab}
                  icon={<SupervisedUserCircleIcon />}
                />
              )}
              {isAdmin && (
                <Tab
                  label="Settings"
                  value="SettingsManagement"
                  style={styles.tab}
                  icon={<SettingsApplicationsIcon />}
                />
              )}
            </Tabs>
          </Box>
          {user && isSignedIn && (
            <Grid container justify="flex-end">
              <Profile handleMenuChange={handleMenuChange} />
            </Grid>
          )}
        </Toolbar>
      </AppBar>
    </MuiThemeProvider>
  );
};

export default TopNavBar;
